import { createRoutine } from 'redux-saga-routines';
import { ACTION_COMPANY_ANALYSTS_MODAL_TOGGLE } from '@company/constants/constants';

export default createRoutine(ACTION_COMPANY_ANALYSTS_MODAL_TOGGLE);
